/*
 * ByLamari: Produktseite des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026), Teil 5.
 * Regeln für „Der Look dazu“ wie routes/look-daten.tsx (Expertenrunde, docs-intern/look-experten.md), im Browser
 * gerechnet: Vetos Metall, Motiv, ein Hauptstück, eine Akzentfarbe, Motiv-Dosis, Perlen ohne Steine; Punkte für
 * genannte Partner, gleiche Reihe, gleiches Motiv, Motiv-Welt, Kollektion; Anzeige vom Gesicht zur Hand.
 * Nutzt assets/bl-produkt-3.js über BL.pdp.look.
 */
(function () {
  var BL = (window.BL = window.BL || {});
  var P = BL.pdp;
  if (!P) return;
  var ART_NAME = { kette: 'Kette', ohrring: 'Ohrringe', ring: 'Ring', armband: 'Armband' };
  var LOOK_REIHE = { kette: ['ohrring', 'ring', 'armband'], ohrring: ['kette', 'ring', 'armband'], armband: ['ring', 'kette', 'ohrring'] };
  var THEMEN = { himmel: 'Moon & Me', 'muscheln-meerestiere': 'Ocean Babe', 'wellen-blau': 'Blue Mood', blumen: 'Flower Club', 'perlen-perlmutt': 'Pearly Queen', 'herz-kirsche': 'Lovecore', 'tropfen-funkeln': 'Glow Drop', 'schwarz-weiss': 'Noir & Blanc', 'muenzen-struktur': 'Vintage Vault' };
  var KEIN_MOTIV = ['edelstahl', 'gold', 'silber', 'bicolor', 'geschenk', 'mix', 'rot', 'blau', 'weiß', 'schwarz', 'zirkonia', 'marmor-optik'];
  var STIL = ['minimalistisch', 'modern', 'organisch', 'statement', 'vintage', 'geometrisch'];
  var GLEICH = { perlen: 'perle', perlmutt: 'perle', coin: 'münze', rose: 'blume' };
  var ANZEIGE = { perle: 'Perle', 'münze': 'Münze', blume: 'Blume' };
  var FAMILIE = { mond: 'himmel', sonne: 'himmel', stern: 'himmel', himmlisch: 'himmel', blitz: 'himmel', muschel: 'meer', seestern: 'meer', seepferdchen: 'meer', 'schildkröte': 'meer', ammonit: 'meer', fisch: 'meer', welle: 'meer', blume: 'blume', blatt: 'blume', herz: 'liebe', kirsche: 'liebe', chili: 'glueck', umarmung: 'liebe', unendlichkeit: 'liebe', perle: 'perle', tropfen: 'glanz', schleife: 'glanz', 'münze': 'muenze', feder: 'feder', spirale: 'kontrast', auge: 'kontrast' };
  var FAMILIE_NAME = { himmel: 'Himmel', meer: 'Meer', blume: 'Blumen', liebe: 'Liebe', perle: 'Perle', glanz: 'Glanz', muenze: 'Münze', feder: 'Feder', glueck: 'Glücksbringer', kontrast: 'Kontrast' };
  var METALL_VON = { gold: 'gold', silber: 'silber', bicolor: 'bicolor', mix: 'bicolor' };
  var LAUT = /auffälligste|größtes|Blickfang|braucht neben sich kein|braucht es keinen|allein stehen|allein zu stehen|reicht er allein|sitzt am besten allein|lautere|Vollversion|vollflächig|fällt deutlich mehr auf|den ganzen Look tragen/i;
  function schmuckArt(t, y) {
    var s = (t + ' ' + (y || '')).toLowerCase();
    if (s.indexOf('kette') > -1 || s.indexOf('necklace') > -1) return 'kette';
    if (s.indexOf('creole') > -1 || s.indexOf('ohrring') > -1 || s.indexOf('ohrstecker') > -1) return 'ohrring';
    if (s.indexOf('armreif') > -1 || s.indexOf('armband') > -1 || s.indexOf('bracelet') > -1) return 'armband';
    return 'ring';
  }
  function hat(set, x) { return set.indexOf(x) > -1; }
  function schnitt(a, b) { return a.filter(function (x) { return hat(b, x); }); }
  function stueck(p) {
    var motive = {}, mk = [], stile = [];
    (p.g || []).forEach(function (tag) {
      var t = tag.trim().toLowerCase();
      if (!t || hat(KEIN_MOTIV, t)) return;
      if (hat(STIL, t)) stile.push(t); else { var k = GLEICH[t] || t; if (!(k in motive)) mk.push(k); motive[k] = tag.trim(); }
    });
    var varianten = p.v.filter(function (v) { return v[1] && v[2] > 0; }).map(function (v) { return { id: v[0], farbe: v[3], preis: v[2] }; });
    var fam = [];
    mk.forEach(function (m) { var f = FAMILIE[m] || m; if (!hat(fam, f)) fam.push(f); });
    var metalle = [];
    varianten.forEach(function (v) { var m = METALL_VON[(v.farbe || '').toLowerCase()]; if (m && !hat(metalle, m)) metalle.push(m); });
    var t = p.d || '';
    if (!metalle.length) {
      if (/goldfarbenen Teile|eines goldfarben|Silber und Gold/i.test(t)) metalle = ['bicolor'];
      else if (/in Silberfarbe, nicht vergoldet/i.test(t)) metalle = ['silber'];
      else { var kb = Object.keys(p.fb || {}); metalle = kb.length === 1 ? kb : ['gold']; }
    }
    var tags = (p.g || []).map(function (x) { return x.toLowerCase(); }), ak = [];
    if (hat(tags, 'rot') || hat(tags, 'chili') || /\brote\b/i.test(t)) ak.push('rot');
    if (hat(tags, 'blau') || /türkis|Keramik/i.test(t)) ak.push('blau');
    if (/Pink|rosafarben/i.test(t)) ak.push('rosa');
    if (hat(tags, 'schwarz')) ak.push('schwarz');
    return {
      p: p, art: schmuckArt(p.t, p.y), vorname: (p.t.trim().split(/\s+/)[0] || '').toLowerCase(), motive: motive, mk: mk, familien: fam, stile: stile,
      themen: (p.c || []).filter(function (h) { return h in THEMEN; }), metalle: metalle, akzente: ak,
      laut: hat(stile, 'statement') || LAUT.test(t), zirkonia: /Zirkonia/i.test(t) || hat(tags, 'zirkonia'),
      echtePerle: /Süßwasserperle|Perlmutt|Kunstperle|\bPerlen?\b/.test(t) && !/Perlenoptik|Perlenstruktur/.test(t), nennt: [], varianten: varianten
    };
  }
  function zufall(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619); return (h >>> 0) / 4294967296; }
  function passtMetall(k, m) { return m === 'bicolor' || hat(k.metalle, m) || hat(k.metalle, 'bicolor'); }
  function bewerte(dies, k, lk, metall) {
    if (!passtMetall(k, metall)) return null;
    var gemeinsam = k.mk.filter(function (m) { return m in dies.motive; });
    var familie = k.familien.filter(function (f) { return hat(dies.familien, f); })[0];
    var themen = schnitt(k.themen, dies.themen).length;
    var genannt = hat(k.nennt, dies.p.h) || hat(dies.nennt, k.p.h);
    var bezug = 0, grund = '';
    if (genannt) { bezug = 100; grund = 'Im Produkttext als Partner genannt'; }
    else if (k.vorname === dies.vorname && (gemeinsam.length || familie)) { bezug = 90; grund = 'Aus derselben Reihe'; }
    else if (gemeinsam.length) { bezug = 60; grund = 'Gleiches Motiv: ' + (ANZEIGE[gemeinsam[0]] || k.motive[gemeinsam[0]]); }
    else if (familie && k.mk.length && dies.mk.length) { bezug = 35; grund = 'Verwandtes Motiv aus der Welt ' + (FAMILIE_NAME[familie] || familie); }
    else if (!k.mk.length) { if (dies.mk.length || themen || k.stile.some(function (s) { return hat(dies.stile, s); })) { bezug = 20; grund = 'Schlichter Begleiter im selben Ton'; } }
    else if (!dies.mk.length && themen) { bezug = 20; grund = 'Aus derselben Motiv-Welt'; }
    if (!bezug) return null;
    if (k.mk.length && dies.mk.length && !gemeinsam.length && !familie && !genannt) return null;
    if (k.laut && lk.some(function (s) { return s.laut; })) return null;
    if (k.akzente.length) for (var i = 0; i < lk.length; i++) { var s = lk[i]; if (s.akzente.length && !s.akzente.some(function (a) { return hat(k.akzente, a); })) return null; }
    for (var j = 0; j < k.mk.length; j++) {
      var m = k.mk[j], schon = lk.filter(function (s) { return m in s.motive; }).length;
      if (schon >= (m === 'perle' ? 3 : 2)) return null;
    }
    if ('perle' in dies.motive && k.zirkonia) return null;
    if ('perle' in k.motive && dies.zirkonia && !('perle' in dies.motive)) return null;
    var punkte = bezug + Math.min(themen, 2) * 15;
    if (k.stile.some(function (s) { return s !== 'statement' && hat(dies.stile, s); })) punkte += 3;
    var nurDiese = k.metalle.length === 1 && hat(k.metalle, metall);
    if (metall !== 'bicolor' && (nurDiese || (k.p.fb || {})[metall])) punkte += 4;
    if (metall === 'bicolor' && hat(k.metalle, 'bicolor')) punkte += 4;
    if (k.laut) punkte -= 10;
    var reihe = dies.art === 'ring' ? [] : LOOK_REIHE[dies.art];
    punkte += [12, 6, 0][reihe.indexOf(k.art)] || 0;
    if ('perle' in dies.motive && 'perle' in k.motive && k.echtePerle) punkte += 6;
    if (k.akzente.some(function (a) { return hat(dies.akzente, a); })) punkte += 3;
    if (themen && bezug <= 35) grund += ', gleiche Motiv-Welt';
    return { punkte: punkte + zufall(dies.p.h + '|' + k.p.h), bezug: bezug + Math.min(themen, 2) * 15, grund: grund };
  }
  function teil(s, metall, istDieses, woerter) {
    var mv = function (m) { return s.varianten.filter(function (v) { return METALL_VON[(v.farbe || '').toLowerCase()] === m; })[0]; };
    var v = (metall ? mv(metall) : null) || (metall ? mv('bicolor') : null) || s.varianten.filter(function (x) { return x.farbe && hat(woerter, x.farbe.toLowerCase()); })[0] || s.varianten[0];
    if (!v) return null;
    var farbe = s.varianten.length > 1 ? v.farbe : null;
    var fb = s.p.fb || {};
    return {
      handle: s.p.h, title: s.p.t, art: s.art, artName: ART_NAME[s.art], istDieses: istDieses,
      bild: (farbe ? fb[farbe.toLowerCase()] : null) || s.p.f || null, farbe: farbe, varianteId: v.id, preis: v.preis,
      varianten: s.varianten, ziel: farbe ? '/products/' + s.p.h + '?Farbe=' + encodeURIComponent(farbe) : '/products/' + s.p.h
    };
  }
  function zusammen(dies, pool, farbe) {
    var gf = farbe ? farbe.toLowerCase() : null;
    var ohne = function () { var t = teil(dies, null, true, []); return { teile: t ? [t] : [], motiv: null, kollektion: null }; };
    if (dies.art === 'ring') return ohne();
    var gm = METALL_VON[gf || ''];
    var metall = (gm && hat(dies.metalle, gm) ? gm : null) || METALL_VON[((dies.varianten[0] || {}).farbe || '').toLowerCase()] || dies.metalle[0] || 'gold';
    var lk = [dies], offen = LOOK_REIHE[dies.art].slice(), max = dies.mk.length ? 3 : 2;
    while (lk.length - 1 < max && offen.length) {
      var best = null;
      pool.forEach(function (k) {
        if (!hat(offen, k.art) || k.p.h === dies.p.h || !k.p.a || !k.varianten.length) return;
        var b = bewerte(dies, k, lk, metall);
        if (!b) return;
        if (lk.length - 1 >= 2 && b.bezug < 35) return;
        if (!best || b.punkte > best.b.punkte) best = { s: k, b: b };
      });
      if (!best) break;
      lk.push(best.s);
      offen.splice(offen.indexOf(best.s.art), 1);
    }
    var reihe = LOOK_REIHE[dies.art];
    lk.sort(function (a, b) { return a === dies ? -1 : b === dies ? 1 : reihe.indexOf(a.art) - reihe.indexOf(b.art); });
    var gew = lk.slice(1);
    if (!gew.length) return ohne();
    var motiv = null;
    for (var i = 0; i < dies.mk.length && !motiv; i++) { var m = dies.mk[i]; if (gew.some(function (k) { return m in k.motive; })) motiv = ANZEIGE[m] || dies.motive[m]; }
    var kollektion = null, meiste = 0;
    dies.themen.forEach(function (h) { var n = gew.filter(function (k) { return hat(k.themen, h); }).length; if (n > meiste) { meiste = n; kollektion = { handle: h, titel: THEMEN[h] || h }; } });
    var woerter = kollektion ? kollektion.handle.split('-') : [];
    var teile = lk.map(function (s, i) { return i === 0 ? teil(s, METALL_VON[gf || ''] || null, true, []) : teil(s, metall, false, woerter); }).filter(Boolean);
    return { teile: teile, motiv: motiv, kollektion: kollektion };
  }
  function bauePool(liste) {
    var pool = liste.map(stueck);
    var titel = pool.map(function (s) { return [s.p.t.trim(), s.p.h]; }).filter(function (x) { return x[0].indexOf(' ') > -1; });
    pool.forEach(function (s) { titel.forEach(function (x) { if (x[1] !== s.p.h && (s.p.d || '').indexOf(x[0]) > -1) s.nennt.push(x[1]); }); });
    return pool;
  }
  P.look = { bauePool: bauePool, zusammen: zusammen };
})();